import ProfileHeader from "../../../components/mandoub-components/profileheader/ProfileHeader"
import GiftTarget from '../../../components/mandoub-components/gift/GiftTarget'
import Target from '../../../components/mandoub-components/targets/Target'
import News from '../../../components/mandoub-components/news/News'
import TopContributor from '../../../components/mandoub-components/top-contributor/TopContributor'
import TransactionContributions from './components/transaction-contributions/TransactionContributions'
import SalaryChart from '../../../components/home-charts/SalaryChart'
import OrdersChart from '../../../components/home-charts/OrdersChart'
import { useFetchData } from '../../../hooks/useFetchData'

function Home() {
  const {data} = useFetchData("mandoub/ranking");
  const {data: competitionData} = useFetchData("mandoub/competition?scope=competition")
  console.log("competitionData is" ,competitionData);

  return (
    <div className='df-c'>

      <ProfileHeader />
      <News />
      <div className="df-c !items-center w-full !gap-8 g-stats">

      <div className="df sm-df-c sm-w-full ai-stretch w-full">
        <SalaryChart />
        <OrdersChart />

      </div>
      <TransactionContributions />

      </div>
      {competitionData && (
        <>
          {competitionData.competitionData
            .filter(item => new Date(item.endDate) > Date.now()) 
            .map((item) => (
              <GiftTarget
                key={item._id}
                competition={item}
                isHidden={new Date(item.startDate) > Date.now()} 
              />
            ))}
        </>
      )}
      <Target />
      {data && data.rankings && data.rankings.weeklyContributionRanking&& <TopContributor array={data.rankings.weeklyContributionRanking }title={"أكثر الموظفين إسهامًا هذا الأسبوع"}/>}
      {data && data.rankings && data.rankings.totalSalesRanking&& <TopContributor allRank={data.rankings.totalSalesRanking }title={"أكثر الموظفين إسهامًا  "}/>}
      {/* <TopContributor title={"أكثر الموظفين إسهامًا من مجموعتك"} /> */}

    </div>
  )
}

export default Home